// VietnamPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import DrpEduNavbar from "../../components/DrpEduNavbar";

const VietnamPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in Vietnam</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Basic Information</h2>
          <ul>
            <li>
              <strong>Degree:</strong> Doctor of Philosophy (PhD)
            </li>
            <li>
              <strong>Duration:</strong> 3 to 5 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>
                  Master’s degree (or exceptional Bachelor’s Honours in some
                  cases)
                </li>
                <li>Research proposal and academic publications (preferred)</li>
                <li>
                  English or Vietnamese proficiency (TOEFL/IELTS may be required
                  for English programs)
                </li>
              </ul>
            </li>
            <li>
              <strong>Admission Process:</strong>
              <ul>
                <li>Written test or interview (varies by university)</li>
                <li>
                  Submission of research proposal, recommendation letters,
                  transcripts
                </li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Government-funded scholarships (e.g., Vingroup Innovation
                  Foundation)
                </li>
                <li>
                  University scholarships and teaching/research assistantships
                </li>
                <li>Tuition is generally low; cost of living is affordable</li>
                <li>
                  Monthly stipends: USD 300–600 depending on the university and
                  funding
                </li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Basic Information</h2>
          <ul>
            <li>
              <strong>Position:</strong> Postdoctoral Research Fellow or
              Research Scientist
            </li>
            <li>
              <strong>Duration:</strong> 1 to 3 years, extendable
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>PhD in a relevant field</li>
                <li>
                  Proven research and publication record (SCI/Scopus-indexed
                  preferred)
                </li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Funded by national programs (e.g., Nafosted), foreign
                  collaborations, or internal university grants
                </li>
                <li>
                  Salary: Typically USD 600–1,200/month depending on field and
                  experience
                </li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in Vietnam</h2>
          <ol>
            <li>
              <strong>Vietnam National University, Hanoi (VNU Hanoi)</strong>
              <p>
                Top university for science, engineering, and social sciences.
                Offers doctoral programs in both Vietnamese and English.
              </p>
            </li>
            <li>
              <strong>
                Vietnam National University, Ho Chi Minh City (VNUHCM)
              </strong>
              <p>
                Renowned for PhD programs in science, engineering, economics,
                and IT. Multiple member universities under its system.
              </p>
            </li>
            <li>
              <strong>Hanoi University of Science and Technology (HUST)</strong>
              <p>
                Leading in engineering, computer science, and applied research.
                Strong industry collaboration and international PhD programs.
              </p>
            </li>
            <li>
              <strong>University of Science, VNU-HCMC</strong>
              <p>
                Known for research in life sciences, chemistry, and
                environmental studies. Offers English-medium PhD in select
                disciplines.
              </p>
            </li>
            <li>
              <strong>Ton Duc Thang University (TDTU), Ho Chi Minh City</strong>
              <p>
                Rapidly rising research university with good publication record.
                English-language PhD and postdoc opportunities, especially in
                science and engineering.
              </p>
            </li>
            <li>
              <strong>Ho Chi Minh City University of Technology (HCMUT)</strong>
              <p>
                Top tech and engineering institution. Research-focused, with
                international partnerships for PhD/postdoc.
              </p>
            </li>
            <li>
              <strong>International University – VNU HCMC</strong>
              <p>
                Offers international-standard research programs in business,
                biotech, and IT. English-taught graduate programs with overseas
                links.
              </p>
            </li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default VietnamPhD;
